import { Link, useNavigate } from "react-router-dom";
import { useState, useContext } from "react";
import axios from "axios";
import { AuthContext } from "../helpers/AuthContext";

function Login() {
  const { setAuthState } = useContext(AuthContext);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  let navigate = useNavigate();

  const login = () => {
    const data = { email: email, password: password };
    axios.post("https://verbalvortex-server.onrender.com/auth/login", data).then((response) => {
      if (response.data.error) {
        alert(response.data.error);
      } else {
        localStorage.setItem("accessToken", response.data.token);
        setAuthState({
          username: response.data.username,
          id: response.data.id,
          status: true,
        });
        navigate("/rules");
      }
    });
  };

  return (
    <div className="Login">
      <div className="Login__form">
        <h2>WELCOME BACK!</h2>
        <input
          onChange={(event) => {
            setEmail(event.target.value);
          }}
          type="email"
          placeholder="Email address *"
        />
        <input
          onChange={(event) => {
            setPassword(event.target.value);
          }}
          type="password"
          placeholder="Password *"
        />

        <button onClick={login}> Log in </button>
        <p>
          Don't have an account?{" "}
          <Link to="/registration" id="Signup-link">
            Sign up
          </Link>
        </p>
      </div>
    </div>
  );
}

export default Login;
